var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      [
        _c(
          "el-form",
          {
            ref: "ruleForm",
            staticClass: "demo-ruleForm",
            attrs: { model: _vm.ruleForm, "label-width": "150px" }
          },
          [
            _c(
              "el-form-item",
              {
                attrs: {
                  label: "Email",
                  prop: "email",
                  rules: [
                    {
                      required: true,
                      message: "Please enter the E-mail!",
                      trigger: "blur"
                    },
                    {
                      type: "email",
                      message: "Please enter the correct email address",
                      trigger: ["blur", "change"]
                    }
                  ]
                }
              },
              [
                _c("el-input", {
                  attrs: {
                    oninput: "if(value){value=value.toLowerCase()}",
                    onblur: "if(value){value=value.trim()}"
                  },
                  model: {
                    value: _vm.ruleForm.email,
                    callback: function($$v) {
                      _vm.$set(_vm.ruleForm, "email", $$v)
                    },
                    expression: "ruleForm.email"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-form-item",
              {
                attrs: {
                  label: "Verification Code",
                  prop: "verifyCode",
                  rules: {
                    required: true,
                    message: "Please enter the E-mail verification code!",
                    trigger: "blur"
                  }
                }
              },
              [
                _c(
                  "div",
                  { staticClass: "flex" },
                  [
                    _c("el-input", {
                      model: {
                        value: _vm.ruleForm.verifyCode,
                        callback: function($$v) {
                          _vm.$set(_vm.ruleForm, "verifyCode", $$v)
                        },
                        expression: "ruleForm.verifyCode"
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        staticStyle: { width: "100px" },
                        on: { click: _vm.getCaptcha }
                      },
                      [_vm._v(_vm._s(_vm.timeValue))]
                    )
                  ],
                  1
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "el-form-item",
              { attrs: { wrapperCol: { span: 19, offset: 5 } } },
              [
                _c(
                  "el-button",
                  {
                    staticClass: "btn",
                    attrs: { type: "primary" },
                    on: {
                      click: function($event) {
                        return _vm.nextStepHandle("ruleForm")
                      }
                    }
                  },
                  [_vm._v("Next")]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4a7560a8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a7560a8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/forget/Step2.vue
// module id = FhCo
// module chunks = 2